import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './CinematicBanner.css';

// Import local assets
import spices5Img from '../assets/spices5.jpg';

const CinematicBanner = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section className="cinematic-banner" ref={ref}>
      <div className="cinematic-bg">
        <img
          src={spices5Img}
          alt="Spice collection"
        />
        <div className="cinematic-overlay" />
      </div>

      <div className="cinematic-content">
        <motion.p
          className="cinematic-pre"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          — From the heart of India —
        </motion.p>
        <motion.h2
          className="cinematic-title"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ delay: 0.2, duration: 1, ease: [0.19, 1, 0.22, 1] }}
        >
          Every Dish Deserves
          <br />
          <span className="gradient-text">Ragini's Touch</span>
        </motion.h2>
        <motion.div
          className="cinematic-ctas"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.4, duration: 0.7 }}
        >
          <a href="/products" className="btn-primary">
            <span>View Collection</span>
            <div className="btn-shine" />
          </a>
          <a href="/recipes" className="btn-outline">Explore Recipes</a>
        </motion.div>
      </div>

      {/* Decorative lines */}
      <div className="cinematic-lines">
        <span /><span /><span />
      </div>
    </section>
  );
};

export default CinematicBanner;
